import { compose, lifecycle } from "recompose";
import { connect } from "react-redux";
import { State } from "../../../reducers/reducer";
import EditableTableView from "../../../views/DashboardView/SustainabilityView/AllocationView/MultiStepView/components/EditableTable";
import { editAllocatedData } from "../../../reducers/sustainability/allocation/multiStep/index";

interface Props {
  data: any[];
  activeStep: number;
  allocated: any;
  available_quantities_part1: any;
  available_quantities_part2: any;
  available_quantities_construction: any;
  editAllocatedData: any;
}

export default compose<Props, {}>(
  connect(
    (state: State) => ({
      data:
        state.sustainability.allocation.multiStep.steps[
          state.sustainability.allocation.multiStep.activeStep
        ].data,
      allocated:
        state.sustainability.allocation.multiStep.steps[
          state.sustainability.allocation.multiStep.activeStep
        ].allocated,
      activeStep: state.sustainability.allocation.multiStep.activeStep,
      available_quantities_part1:
        state.sustainability.allocation.multiStep.available_quantities_part1,
      available_quantities_part2:
        state.sustainability.allocation.multiStep.available_quantities_part2,
      available_quantities_construction:
        state.sustainability.allocation.multiStep
          .available_quantities_construction,
    }),
    (dispatch: any) => ({
      dispatch,
      editAllocatedData: (
        id: number,
        index: number,
        value: number,
        isDoubleCount: boolean,
        isDiesel: boolean
      ) =>
        dispatch(editAllocatedData(id, index, value, isDoubleCount, isDiesel)),
    })
  ),
  lifecycle<Props, State>({
    componentDidMount() {},
  })
)(EditableTableView);
